<template>
    <div>
        <touchpoint-overview-row
            class="info-row info-row-header"
        >
            <template slot="left">
                <touchpoint-overview-icon-circle class="info-circle" color="blue"/>
            </template>

            <template slot="center">
                <span class="description">{{direction}}</span>
                
                <br />

                <i class="fas fa-3x fa-long-arrow-alt-right direction-marker"/>
            </template>
            
            <template slot="right">
                <touchpoint-overview-icon-circle class="info-circle" color="green"/>
            </template>
        </touchpoint-overview-row>

        <touchpoint-info-connection-list-row
            v-for="connectionInfo in connectionsInfo"

            class="info-row"
            :key="connectionInfo.connectionId"
            :connection-name="connectionInfo.connectionName"

            :source-brick-name="connectionInfo.sourceBrickName"
            :source-brick-type="connectionInfo.sourceBrickType"
            :source-brick-config="connectionInfo.sourceBrickConfig"

            :destination-brick-name="connectionInfo.destinationBrickName"
            :destination-brick-type="connectionInfo.destinationBrickType"
            :destination-brick-config="connectionInfo.destinationBrickConfig"

            :source-conditions="connectionInfo.sourceConditions"

            :destination-condition-description="connectionInfo.destinationConditionDescription"
        />
    </div>
</template>

<script>
    import TouchpointOverviewRow from "./TouchpointOverviewRow.vue";
    import TouchpointInfoConnectionListRow from "./TouchpointInfoConnectionListRow.vue";
    import TouchpointOverviewIconCircle from "./TouchpointOverviewIconCircle.vue";
    
    export default {
        name: 'touchpoint-info-connection-list',
        components: {
            TouchpointOverviewRow,
            TouchpointInfoConnectionListRow,
            TouchpointOverviewIconCircle
        },
        props: {
            connectionsInfo: {
                type: Array,
                required: true
            },
            direction: {
                type: String,
                required: true
            }
        }
    }
</script>

<style scoped src="../../../Style/touchpoint-info-connection-list.scss" lang="scss">
    
</style>
